import Marquee from "react-fast-marquee";

const WORDS = ["Vision", "Autorité", "Vertu", "Audace", "Vie"];

export const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="bg-bone py-8 border-y border-linen overflow-hidden">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {Array.from({ length: 4 }).map((_, i) => (
        <span key={i} className="flex items-center">
          {WORDS.map((w) => (
            <span key={`${i}-${w}`} className="flex items-center">
              <span className="font-serif italic text-3xl md:text-4xl text-ink/70 px-10">{w}</span>
              <span className="w-2 h-2 rounded-full bg-sage/60 inline-block" />
            </span>
          ))}
        </span>
      ))}
    </Marquee>
  </div>
);
